import React from "react";
import { withStyles, Card, CardContent, CardActionArea } from "@material-ui/core";
import {BillDiff} from "./BillDiff";
import constant from "./constant";

const styles = theme => ({
    container:{
        backgroundColor:"transparent",
        '& $content':{
            padding:"4px 8px",
        }
    },
    zone:{
        height:"100%"
    },
    zoneActive:{
       '& $content':{
           backgroundColor: theme.trailerCardSelectedColor
       }
    },
    content:{
        border:`1px solid ${theme.tooltipBGColor}`,
        color: theme.gridTextColor,
        minWidth: 120,
        height:"100%",
        borderRadius: 4,
        backgroundColor: theme.gridBGColor,
        fontSize:12,
        padding:"4px 8px",
        cursor:"pointer"
    },
    name:{
        padding:4,
        color: theme.gridTextColor,
        fontSize:10
    },
    billDetails:{
        textAlign:"center",
        padding:8,
        margin:"0 -8px",
        minHeight:75,
        color: theme.gridTextColor
    },
    totalBillCount:{
        fontSize:30,
        fontWeight:600,
        color: theme.TextColor,
        opacity:0.75
    },
    billType:{
        fontSize:9,
        lineHeight:"13px",
    },
    billDiff:{
        lineHeight:"13px",
        fontSize:9
    },
    billDiffContainer:{
        color: theme.gridTextColor,
        fontSize:9,
        padding: "8px 24px 0 24px",
    },
    divider:{
        borderTop:`1px solid ${theme.iconColor}`,
        width:"80%",
        margin:"auto",
        // boxShadow:`0px 1px 1px 0px ${theme.iconColor}`,
        opacity:"0.7"
    },
    missedBillsContainer:{
        paddingBottom:8,
        '&>$billCount':{
            color: theme.ErrorMessageColor,
        },
        '&:hover':{
            backgroundColor: theme.errorBGColor,
            color: theme.TextColor
        },
        '&$isActive':{
            backgroundColor: theme.errorBGColor
        }       
    },
    extraBillsContainer:{
        paddingBottom:8,
        '&>$billCount':{
            color: theme.trailerExtraBillsColor
        },
        '&:hover':{
            backgroundColor: theme.warningBGColor,
            color: theme.TextColor
        },
        '&$isActive':{
            backgroundColor: theme.warningBGColor
        }      
    },
    matchedBillsContainer:{
        paddingBottom:8,
        '&>$billCount':{
            color: theme.palette.primary.main,
        },
        '&:hover':{
            backgroundColor: theme.infoBGColor,
            color: theme.TextColor
        },
        '&$isActive':{
            backgroundColor: theme.infoBGColor
        }
    },
    billCount:{
        padding:"0 12px",
        fontSize:16,
        fontWeight:600
    },
    isActive:{
        color: theme.TextColor
    }

})

class LoadingZone extends React.PureComponent {    
    
    applyFilter = event => {
        event.stopPropagation();
        if(this.props.updateFilter){
            const { filteredProType, data, isFilteredZone} = this.props;
            const selectedFilterProType = event.currentTarget.getAttribute('data-protype') || null; 
            // if the proType changed then update the value else unselect the current proType           
            const proType = selectedFilterProType === filteredProType ? null : selectedFilterProType; 
            // clear zone selection when filters are removed
            const selectZone = !selectedFilterProType && !filteredProType && isFilteredZone ? null :data.loadingZone;

            this.props.updateFilter({
                loadingZone: selectZone,
                proType: proType,
                routeType: null
            });
        }
    }

    getDifferenceText = (differenceValue) => {        
        if(differenceValue > 0){
            return `Increased`;
        } else if(differenceValue < 0){
            return `Decreased`;
        }
        return "No Change"
    }

    render(){
        const { zoneName , classes, billType ,  isFilteredZone, filteredProType, showBillDetails } = this.props;
        const { totalBills, missedBills, extraBills, matchedBills, difference  } = this.props.data;
        return (
            <Card raised={isFilteredZone} classes={{root: `${classes.container} ${isFilteredZone ? classes.zoneActive: ""}`}}>
                <CardActionArea classes={{root:classes.zone}}>
                    <CardContent classes={{root: classes.content}} onClick={this.applyFilter}>
                            <div className={classes.name}>{zoneName}</div>
                            <div className={classes.billDetails}>
                                <div className={classes.totalBillCount}> { totalBills } </div>
                                <div className={classes.billType}> { billType } </div>
                                { showBillDetails  && <div className={classes.billDiff}> { this.getDifferenceText(difference) } </div>}
                            </div>
                            {
                                showBillDetails && (
                                    <div>
                                    <div className={classes.divider}></div>
                                    <div className={classes.billDiffContainer}>
                                        <BillDiff 
                                            containerClass={`${classes.missedBillsContainer} ${filteredProType === constant.PRO_TYPE.MISSED ?  classes.isActive :""}`} 
                                            countClass={classes.billCount} 
                                            billCount={missedBills}
                                            proType={constant.PRO_TYPE.MISSED}
                                            onClick={this.applyFilter}                                         
                                        > 
                                            Missed Bills 
                                        </BillDiff>
                                        <BillDiff 
                                            containerClass={`${classes.extraBillsContainer} ${filteredProType === constant.PRO_TYPE.EXTRA ?  classes.isActive :""}`}
                                            countClass={classes.billCount} 
                                            billCount={extraBills}
                                            proType={constant.PRO_TYPE.EXTRA}
                                            onClick={this.applyFilter}
                                        > 
                                            Extra Bills 
                                        </BillDiff>
                                        <BillDiff 
                                            containerClass={`${classes.matchedBillsContainer} ${filteredProType === constant.PRO_TYPE.MATCHED ?  classes.isActive :""}`}
                                            countClass={classes.billCount} 
                                            billCount={matchedBills}
                                            proType={constant.PRO_TYPE.MATCHED}
                                            onClick={this.applyFilter}
                                        > 
                                            Matched Bills 
                                        </BillDiff>
                                    </div>
                                    </div>
                                )
                            }
                    </CardContent>
                </CardActionArea>
            </Card>
        )
    }
}


export default withStyles(styles)(LoadingZone)